// src/components/Footer.jsx
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import logo from '../Navbar/logo.jpeg'; // mismo logo que usa Navbar.jsx - ajusta la ruta si vive en otra carpeta

export default function Footer() {
  const { t } = useTranslation();

  const navigation = {
    hotel: [
      { name: t("footer.rooms") || "Rooms", href: "/rooms" },
      { name: t("footer.myBookings") || "My Bookings", href: "/my-bookings" },
      { name: t("footer.myDogs") || "My Dogs", href: "/dogs" },
    ],
    support: [
      { name: t("footer.contact") || "Contact", href: "mailto:hola@doghotel.com" },
      { name: t("footer.privacyPolicy") || "Privacy Policy", href: "/privacy-policy" },
      { name: t("footer.terms") || "Terms of Service", href: "/terms-of-service" },
    ],
    social: [
      {
        name: "Instagram",
        href: "https://www.instagram.com/hotel_macarios/",
        icon: (props) => (
          <svg fill="currentColor" viewBox="0 0 24 24" {...props}>
            <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" />
          </svg>
        ),
      },
    ],
  };

  return (
    <footer aria-labelledby="footer-heading">
      <h2 id="footer-heading" className="sr-only">
        Footer
      </h2>

      {/* Franja superior oscura - mismo acento de dos tonos que el Navbar */}
      <div className="h-1.5 bg-[#7A0001]" aria-hidden="true" />

      <div className="bg-[#9A0002]">
        <div className="mx-auto max-w-7xl px-6 pb-8 pt-16 sm:pt-24 lg:px-8 lg:pt-32">
          <div className="xl:grid xl:grid-cols-3 xl:gap-8">
            {/* Brand info - mismo logo circular y wordmark que el Navbar */}
            <div className="space-y-8">
              <Link to="/" className="flex items-center">
                <div className="relative h-12 w-12 overflow-hidden rounded-full border-2 border-[#EFE6DD] bg-white">
                  <img className="h-14 w-auto object-contain object-top" src={logo} alt="Hotel Macarios" />
                </div>
                <span className="ml-3 text-xl font-bold text-[#EFE6DD]">Hotel Macarios</span>
              </Link>
              <p className="text-sm leading-6 text-[#EFE6DD]/80">
                {t("footer.tagline", "Luxury boarding and care for your furry friend. Book a suite today!")}
              </p>
              <div className="flex space-x-6">
                {navigation.social.map((item) => (
                  <a
                    key={item.name}
                    href={item.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-[#EFE6DD]/70 hover:text-[#EFE6DD]/70 transition"
                  >
                    <span className="sr-only">{item.name}</span>
                    <item.icon className="h-6 w-6" aria-hidden="true" />
                  </a>
                ))}
              </div>
            </div>

            {/* Links */}
            <div className="mt-16 grid grid-cols-2 gap-8 xl:col-span-2 xl:mt-0">
              <div className="md:grid md:grid-cols-2 md:gap-8">
                <div>
                  <h3 className="text-sm font-semibold leading-6 text-[#EFE6DD]">
                    {t("footer.hotel") || "Hotel"}
                  </h3>
                  <ul role="list" className="mt-6 space-y-4">
                    {navigation.hotel.map((item) => (
                      <li key={item.name}>
                        <Link
                          to={item.href}
                          className="text-sm leading-6 text-[#EFE6DD]/80 hover:text-[#EFE6DD]/70 transition"
                        >
                          {item.name}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="mt-10 md:mt-0">
                  <h3 className="text-sm font-semibold leading-6 text-[#EFE6DD]">
                    {t("footer.support") || "Support"}
                  </h3>
                  <ul role="list" className="mt-6 space-y-4">
                    {navigation.support.map((item) => (
                      <li key={item.name}>
                        <a
                          href={item.href}
                          className="text-sm leading-6 text-[#EFE6DD]/80 hover:text-[#EFE6DD]/70 transition"
                        >
                          {item.name}
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
              {/* You can add a newsletter section later if desired */}
            </div>
          </div>

          {/* Bottom bar - mismo divisor vertical/horizontal que usa el Navbar (EFE6DD/20) */}
          <div className="mt-16 border-t border-[#EFE6DD]/20 pt-8 sm:mt-20 lg:mt-24 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs leading-5 text-[#EFE6DD]/70">
              &copy; {new Date().getFullYear()} Hotel Macarios {t("footer.rights") || "All rights reserved."}
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}